import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { packageIncludes } from '../data/comparison';
export function OfferSection() {
  return <section id="buy" className="flex min-h-[100svh] w-full flex-col justify-center bg-bone py-6 sm:py-20" aria-labelledby="offer-title" data-id="element-144" data-mp="de55l1s0ikjq">
      <div className="mx-auto w-full max-w-md px-4 sm:max-w-lg sm:px-8" data-id="element-145" data-mp="icorx3aipycm">
        <div className="overflow-hidden rounded-2xl border border-court-950/10 bg-white shadow-[0_24px_60px_-32px_rgba(0,0,0,0.45)]" data-id="element-146" data-mp="me1xrddm21jj">
          <p className="bg-court-950 px-4 py-2.5 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ball" data-id="element-147" data-mp="repnlvq3scc6">
            🏆 Paquete Completo
          </p>

          <div className="px-5 pb-5 pt-5 text-center sm:px-8 sm:pb-7 sm:pt-7" data-id="element-148" data-mp="2t6b5sds3vrjy">
            <h2 id="offer-title" className="font-display text-xl font-black uppercase leading-none tracking-tight text-court-950 sm:text-2xl" data-id="element-149" data-mp="2y3uk1dot04bw">
              Tenis 360™
            </h2>
            <p className="mt-1.5 text-xs text-court-700 sm:text-sm" data-id="element-150" data-mp="xw0buw5kw97z">12 Volúmenes + 6 Bonos</p>

            <div className="mt-4 rounded-xl bg-bone px-4 py-3.5 sm:mt-5" data-id="element-151" data-mp="syib3t1pt0b2">
              <p className="text-xs text-court-600 sm:text-sm" data-id="element-152" data-mp="own90mbymiw8">
                Valor total: <span className="line-through" data-id="element-153" data-mp="1lme34kgca41i">$318</span>
              </p>
              <p className="mt-0.5 flex items-end justify-center gap-1.5" data-id="element-154" data-mp="1lka34dlk9p6i">
                <span className="pb-1.5 font-display text-2xl font-black text-court-950" data-id="element-155" data-mp="1gokxbsiy7c1r">$</span>
                <span className="font-display text-5xl font-black leading-none tracking-tight text-court-950 sm:text-6xl" data-id="element-156" data-mp="1ckd6npsxjm0w">
                  19
                </span>
                <span className="pb-1.5 text-xs font-medium text-court-700 sm:text-sm" data-id="element-157" data-mp="172gbbq0879r">
                  pago único
                </span>
              </p>
              <p className="mt-3 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-2" data-id="element-158" data-mp="3sex1xanpe58o">
                <span className="rounded-full bg-clay px-3.5 py-1 text-[11px] font-bold uppercase tracking-wider text-white" data-id="element-159" data-mp="3trwscx73776a">
                  Ahorras $299
                </span>
                <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-court-950" data-id="element-160" data-mp="3ksruzu79hjvp">
                  Acceso de por vida
                </span>
              </p>
            </div>

            <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.18em] text-court-600 sm:text-[11px]" data-id="element-161" data-mp="3b2q7p4mqg5hu">
              Qué incluye
            </p>
            <ul className="mt-3 space-y-2 text-left" data-id="element-162" data-mp="315ls5nne78a0">
              {packageIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[12.5px] leading-snug text-court-800 sm:text-sm" data-id="element-163" data-mp="3645dpmy2qi1u">
                  <span className="mt-px flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-clay/10 sm:h-[18px] sm:w-[18px]" aria-hidden="true" data-id="element-164" data-mp="2s703darbux0s">
                    <CheckIcon className="h-2.5 w-2.5 text-clay" strokeWidth={4} data-id="element-165" data-mp="28j3x9d6o5qpb" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-5" data-id="element-166" data-mp="2ih1irsx599e8">
              <Countdown data-id="element-167" data-mp="2igs0ysm968jm" />
              <p className="mt-1.5 text-[10px] leading-snug text-court-600 sm:text-xs" data-id="element-168" data-mp="2ifgrcc64m6kl">
                Después de eso, el precio sube $5 y no vuelve a bajar.
              </p>
            </div>

            <div className="mt-4" data-id="element-169" data-mp="2rh6rc6e2qdtz">
              <CtaButton size="hero" variant="dark" className="w-full" data-id="element-170" data-mp="366mg5gu1o971">
                🚀 Quiero Tenis 360 — Solo $19
              </CtaButton>
              <p className="mt-2.5 text-[11px] font-semibold text-court-950 sm:text-xs" data-id="element-171" data-mp="318km60v2ypgs">
                💳 Pagarás en tu moneda local
              </p>
              <p className="mt-1.5 flex items-center justify-center gap-1.5 text-[10px] text-court-600 sm:text-xs" data-id="element-172" data-mp="3a87ocovmvzaw">
                <ShieldCheckIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-173" data-mp="18ja9k08jgkql" />
                Respaldado por nuestra garantía de 7 días
              </p>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2 border-t border-court-950/10 pt-4 text-[10px] text-court-700 sm:text-[11px]" data-id="element-174" data-mp="1i8ttl97zmkn1">
              <span className="flex items-center justify-center gap-1.5" data-id="element-175" data-mp="1m95aqc1562tr">
                <LockIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-176" data-mp="pkxvq16ommoo" /> Pago
                Seguro
              </span>
              <span className="flex items-center justify-center gap-1.5" data-id="element-177" data-mp="ujixi51l1ef8">
                <ZapIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-178" data-mp="yjszz7q61mpc" /> Acceso en
                5 min
              </span>
              <span className="flex items-center justify-center gap-1.5" data-id="element-179" data-mp="13hunq5yjea75">
                <ShieldCheckIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-180" data-mp="29zho42f5orrq" />{' '}
                Garantía 7 Días
              </span>
              <span className="flex items-center justify-center gap-1.5" data-id="element-181" data-mp="2p2rgom03lvun">
                <CreditCardIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-182" data-mp="2p4vjt1q6aqtv" />{' '}
                Tarjeta · Transferencia
              </span>
            </div>
          </div>
        </div>

        <p className="mt-3 text-center text-[10px] leading-snug text-court-600 sm:text-xs" data-id="element-183" data-mp="2bbmg9howozj9">
          ⏰ Oferta por tiempo limitado · Todo incluido. Un solo precio. Sin costos ocultos. Sin
          sorpresas. ·{' '}
          <span className="font-semibold text-clay" data-id="element-184" data-mp="21cx84gmtatg7">🔴 Cupos limitados — 72% reclamados</span>
        </p>
      </div>
    </section>;
}